import React from 'react';
import { useDispatch } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { isUndefined, isNull } from 'lodash';

import { useCurrentUser } from '@components/Auth';
import { Loading, LoadingError } from '@components/Base';
import { RightCol } from '@components/HealthQuoteBuyRoute/right-col';
import HealthQuoteBuyForm, { FormValues, FormValuesForCreate } from '@components/HealthQuoteBuyRoute/HealthQuoteBuyForm';

import { personalAccidentQuoteCreate, PersonalAccidentQuoteCreatePayload } from '../action';
import { usePersonalAccidentQuoteFind } from '../hook';
import { useInitialValues } from './hook';

const PersonalAccidentQuoteBuyNewPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  useCurrentUser();
  const personalAccidentQuote = usePersonalAccidentQuoteFind();
  const initialValues = useInitialValues();

  if (isUndefined(personalAccidentQuote)) return <Loading />;
  if (isNull(personalAccidentQuote)) return <LoadingError />;
  if (!initialValues) return null;

  const { personalAccidentPlanQuestions, occupationDeclarationDescription } = personalAccidentQuote;

  const handleSubmit = ({ isConfirmedDeclaration, ...rest }: FormValues) => {
    const payload: PersonalAccidentQuoteCreatePayload = ({ ...rest, personalAccidentPlanId: (rest as FormValuesForCreate).planId }) as PersonalAccidentQuoteCreatePayload;
    dispatch(personalAccidentQuoteCreate(payload));
  };

  return (
    <Container className="my-5">
      <Row>
        <h2>{t('personalAccidentQuoteBuyPage.title')}</h2>
        <p>{t('personalAccidentQuoteBuyPage.subTitle')}</p>
        <Col lg={8}>
          <HealthQuoteBuyForm
            initialValues={initialValues}
            onSubmit={handleSubmit}
            questions={personalAccidentPlanQuestions}
            description={occupationDeclarationDescription} />
        </Col>

        <RightCol {...personalAccidentQuote} planName={personalAccidentQuote.personalAccidentPlanName} />
      </Row>
    </Container>
  );
};

export { PersonalAccidentQuoteBuyNewPage };
